const navConfig = [
  {
    title: "Home",
    path: "/",
  },
  {
    title: "About Us",
    path: "/the-fund",
  },
  {
    title: "Expected Outcomes",
    path: "/expected-outcomes",
  },
  {
    title: "For Funders",
    path: "/for-funders",
  },
  {
    title: "For Grantees",
    path: "/for-grantees",
  },
  {
    title: "Contact Us",
    path: "/contact-us",
  },
];

export default navConfig;
